var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import MuiButton from "@mui/material/Button";
import { baseButtonStylesFn } from "./ButtonV2.styles";
import CircularProgress from "../Progress/CircularProgress";
export var BUTTON_VARIANT;
(function (BUTTON_VARIANT) {
    BUTTON_VARIANT["Primary"] = "primary";
    BUTTON_VARIANT["Secondary"] = "secondary";
    BUTTON_VARIANT["Text"] = "text";
    BUTTON_VARIANT["TextSecondary"] = "textSecondary";
    BUTTON_VARIANT["TextDark"] = "textDark";
    BUTTON_VARIANT["Warning"] = "warning";
    BUTTON_VARIANT["WarningSecondary"] = "warningSecondary";
})(BUTTON_VARIANT || (BUTTON_VARIANT = {}));
export var BUTTON_SIZE;
(function (BUTTON_SIZE) {
    BUTTON_SIZE["Mini"] = "mini";
    BUTTON_SIZE["Small"] = "small";
    BUTTON_SIZE["Medium"] = "medium";
})(BUTTON_SIZE || (BUTTON_SIZE = {}));
var ButtonV2 = function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? BUTTON_SIZE.Medium : _b, loading = _a.loading, children = _a.children, defaultIcon = _a.defaultIcon, startIcon = _a.startIcon, _c = _a.variant, variant = _c === void 0 ? BUTTON_VARIANT.Primary : _c, sx = _a.sx, rest = __rest(_a, ["size", "loading", "children", "defaultIcon", "startIcon", "variant", "sx"]);
    // use provided icon or default
    var icon = defaultIcon ? _jsx(AddIcon, {}) : startIcon;
    // memoizeStyles
    var styles = __assign(__assign({}, baseButtonStylesFn({ loading: loading })), sx);
    return (_jsx(MuiButton, __assign({ variant: variant, size: size, ref: ref, "data-testid": "button-tbd", sx: styles, startIcon: icon }, rest, { children: loading ? (_jsx(CircularProgress, { color: "secondary", style: { width: 14, height: 14 } })) : (children) })));
};
export default forwardRef(ButtonV2);
